import React from "react";
import { LoginForm as CommonLoginForm } from "tds_shared_ui";
import { WithCommonTranslations, WithUser, WithRegion } from "./../hocs";
import { TranslationMixin, withRouter } from "tds_shared_ui";

export const LoginForm = WithRegion(
  withRouter(
    WithUser(
      WithCommonTranslations(
        class LoginForm extends TranslationMixin(React.Component) {
          constructor(props) {
            super(props);
          }
          render() {
            const { onClick, locale, regionData } = this.props;
            return (
              <div>
                <CommonLoginForm
                  registrationLink="/registration"
                  onLinkClick={onClick}
                  locale={locale}
                  regionData={regionData}
                />
              </div>
            );
          }
        }
      )
    )
  )
);